/**
 * Parses the query string even with a leading ? character.
 */
export function parseRawQueryString(qs) {
    return Object.fromEntries(new URLSearchParams(qs));
}

/**
 * Parses a query string, adds custom params and returns a new one (without ?).
 */
export function setQueryParams(qs, params = {}) {
    return new URLSearchParams({
        ...parseRawQueryString(qs),
        ...params
    }).toString();
}